<template>
  <div class="question-content">
    <div class="header" v-if="paperDetail">
      <div class="title">
        {{ paperDetail.title }}
      </div>
      <div class="tip">
        <div class="left">体智云官方</div>
      </div>

      <div class="split-line"></div>
      <div class="rules">
        <div class="item" v-for="(categoryGroup, index) in questionGroupByCategory" :key="index">
          <div class="name">{{ index }}</div>
          <div class="counts">{{ categoryGroup.length }}<span>题</span></div>
        </div>

        <div class="item">
          <div class="name">低难度</div>
          <div class="counts">{{ lowCounts }}<span>题</span></div>
        </div>

        <div class="item">
          <div class="name">中等难度</div>

          <div class="counts">{{ mediumCounts }}<span>题</span></div>
        </div>

        <div class="item">
          <div class="name">高难度</div>
          <div class="counts">{{ highCounts }}<span>题</span></div>
        </div>
      </div>
    </div>

    <div class="question-list">
      <div class="questions">
        <question-info
          v-for="(question, index) in questions"
          :key="index"
          :show-explanation="true"
          :questionInfo="question"
          :seqNo="index + 1"
        ></question-info>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import QuestionInfo from './QuestionInfo.vue'
import { IPaperDetail } from 'kuaidong-model'
import groupBy from 'lodash/groupBy'
@Component({
  components: {
    QuestionInfo,
  },
})
export default class QuestionDetailContent extends BaseComponent {
  @Prop({ type: Object, required: true })
  paperDetail!: IPaperDetail

  get questions() {
    return this.paperDetail.questions
  }

  get questionGroupByCategory() {
    return groupBy(this.questions, 'category')
  }

  get lowCounts() {
    return this.questions.filter((item) => {
      return item.difficulty_level === '简单'
    }).length
  }

  get mediumCounts() {
    return this.questions.filter((item) => {
      return item.difficulty_level === '中等'
    }).length
  }

  get highCounts() {
    return this.questions.filter((item) => {
      return item.difficulty_level === '困难'
    }).length
  }
}
</script>
<style lang="less">
.question-content {
  > .header {
    display: flex;
    flex-direction: column;
    padding: 20px 15px;
    justify-content: flex-start;
    align-items: flex-start;
    background: #fff;
    > .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #2d2f33;
    }
    > .tip {
      margin-top: 20px;
      display: flex;
      flex: 1;
      width: 100%;
      justify-content: space-between;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #8f8f8f;
    }

    > .split-line {
      height: 1px;
      background: #ebebeb;
      width: 100%;
      margin-top: 17px;
      margin-bottom: 17px;
    }
    > .rules {
      padding: 16px 0;
      background: #f7f8fa;
      border-radius: 8px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      width: 100%;
      justify-content: space-around;
      > .item {
        width: 114px;
        > .name {
          font-weight: 400;
          font-size: 12px;
          line-height: 17px;
          color: #4d4d4d;
          text-align: center;
        }

        > .flag {
          margin-top: 4px;
          > img {
            width: 12px;
            height: 12px;
          }
        }
        > .counts {
          margin-top: 4px;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #2d2f33;
          text-align: center;
          > span {
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #2d2f33;
            margin-left: 4px;
          }
        }
      }
    }
  }

  > .question-list {
    margin-top: 8px;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);
    border-radius: 8px;
    padding: 30px;
    background: #fff;
    > .questions {
      padding: 20px;
      background: #f7f8fa;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      > .question-info-comp {
        width: 582px;
        border-radius: 4px;

        &:not(:first-child) {
          border-top: 1px solid #f5f5f5;
        }
      }
    }
  }
}
</style>
